export const COST_CALC_GET_INITIAL_DATA = "COST_CALC_GET_INITIAL_DATA";
export const COST_CALC_GET_INITIAL_DATA_SUCCESS = "COST_CALC_GET_INITIAL_DATA_SUCCESS";
export const COST_CALC_GET_RATINGS = "COST_CALC_GET_RATINGS";
export const COST_CALC_GET_RATINGS_SUCCESS = "COST_CALC_GET_RATINGS_SUCCESS";